import { RECEIVE_REFERREDBY, REQUEST_REFERREDBY } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_REFERREDBY:
            return { ...state, shouldFetch: false }

        case RECEIVE_REFERREDBY:
            return { ...state, ...data }

        default:
            return state
    }
}
